import { getWindow } from '../../../../utils/getWindow';

export const getAuthUrl = () => {
    const clientId = process.env.REACT_APP_DIRECT_OAUTH_CLIENT_ID;
    const redirectUrl = `${getWindow()?.location.origin}/rythm/promotion`;

    return `https://oauth.yandex.ru/authorize?response_type=token&client_id=${clientId}&redirect_uri=${redirectUrl}`;
};
